<template>
  <div class="pill-tags-list__wrapper">
    <ul class="pill-tags-list">
      <li
        v-for="tag in tags"
        :key="tag.id"
        v-tooltip="{
          content: `Search by ${tag.name ? tag.name : tag}`,
          placement: 'right-center',
        }"
        class="pill-tags-list__item"
      >
        <div @click.stop="$emit('tag-click', tag)">
          <PillBadge translucid sober>
            {{ tag.name }}
          </PillBadge>
        </div>
      </li>
      <li
        v-if="extraTag"
        :key="tag"
        v-tooltip="{
          content: extraTagTooltip,
          placement: 'right-center',
        }"
        class="content-row__details-key-concept-list-item"
      >
        <PillBadge translucid sober>
          {{ extraTag }}
        </PillBadge>
      </li>
    </ul>
  </div>
</template>

<script>
import { collectionCommons } from '@/helpers/mixins'
import PillBadge from '@/components/shared/PillBadge.vue'

export default {
  name: 'PillTagsList',
  components: {
    PillBadge,
  },
  mixins: [collectionCommons],
  emits: ['tag-click'],
  props: {
    tags: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.pill-tags-list {
  display: flex;
  flex-flow: wrap;
  list-style-type: none;
  padding: 0;
  gap: 10px;
  &__item {
    display: flex;
    align-items: center;
  }
}
</style>
